import React, { ReactNode } from 'react';
import { Button, Tooltip } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import moment from 'moment';
import ComparisonModeSelect from '../analytics_comparison/ComparisonModeSelect';
import { ComparisonState } from '../../utils/AnalyticsComparisonUtils';
import { cn } from '../../utils/ClassNamesUtils';

export type AnalyticsChartComparisonProps = {
	value: ComparisonState;
	onChange: (next: ComparisonState) => void;
	selectedStart: moment.Moment | null;
	selectedEnd: moment.Moment | null;
	isTimeBased?: boolean;
	loading?: boolean;
	disabled?: boolean;
	disabledReason?: string;
};

export type AnalyticsChartActionsProps = {
	comparison?: AnalyticsChartComparisonProps;
	onDownload?: () => void;
	downloadTooltip?: string;
	/** Extra slot rendered to the right of comparison + download (e.g., custom buttons). */
	extra?: ReactNode;
	size?: string;
};

const AnalyticsChartActions = ({
	comparison,
	onDownload,
	downloadTooltip = 'Download',
	extra,
	size,
}: AnalyticsChartActionsProps) => {
	return (
		<div
			className={cn('flex items-center gap-2 print:!hidden', {
				'[&>*]:!h-10': size === 'large',
			})}
		>
			{comparison ? (
				<ComparisonModeSelect
					value={comparison.value}
					onChange={comparison.onChange}
					selectedStart={comparison.selectedStart}
					selectedEnd={comparison.selectedEnd}
					isTimeBased={comparison.isTimeBased}
					loading={!!comparison.loading}
					disabled={!!comparison.disabled}
					disabledReason={comparison.disabled ? comparison.disabledReason : undefined}
				/>
			) : null}
			{onDownload ? (
				<Tooltip title={downloadTooltip}>
					<Button
						className={cn({ '!size-10': size === 'large' })}
						icon={<DownloadOutlined />}
						onClick={onDownload}
					/>
				</Tooltip>
			) : null}
			{extra}
		</div>
	);
};

export default AnalyticsChartActions;
